// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-navigation_container__aUfd7 {
  background-color: var(--primary-background-color);
  padding: 12px 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  box-shadow: var(--shadow-navigation);
  z-index: 10;
}

.mobile-navigation_item__tA9l5 {
  display: grid;
  grid-template-rows: auto 1fr;
  align-items: center;
  justify-items: center;
  gap: 4px;
  text-decoration: none;
}

.mobile-navigation_icon__v0zsm {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f0c7c7;
}
`, "",{"version":3,"sources":["webpack://./src/components/mobile/mobile-navigation.module.css"],"names":[],"mappings":"AAAA;EACE,iDAAiD;EACjD,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,mBAAmB;EACnB,qBAAqB;EACrB,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B","sourcesContent":[".container {\n  background-color: var(--primary-background-color);\n  padding: 12px 32px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  box-shadow: var(--shadow-navigation);\n  z-index: 10;\n}\n\n.item {\n  display: grid;\n  grid-template-rows: auto 1fr;\n  align-items: center;\n  justify-items: center;\n  gap: 4px;\n  text-decoration: none;\n}\n\n.icon {\n  width: 25px;\n  height: 25px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #f0c7c7;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `mobile-navigation_container__aUfd7`,
	"item": `mobile-navigation_item__tA9l5`,
	"icon": `mobile-navigation_icon__v0zsm`
};
export default ___CSS_LOADER_EXPORT___;
